const WhatShouldAvoidWhenPlanning = Object.freeze({
  PACE_AND_TIMING: 'pace_and_timing',
  CROWDS: 'crowds',
  CLIMATE_AND_SURROUNDINGS: 'climate_and_surroundings',
  FOOD_AND_DRINK: 'food_and_drink',
  WHERE_YOU_STAY: 'where_you_stay',
  ACTIVITIES: 'activities',
  TRANSPORT: 'transport',
  EVENTS_AND_ENTERTAINMENT: 'events_and_entertainment',

  // Retained so existing saved DNA remains valid.
  TOURIST_TRAPS: 'tourist_traps',
  EARLY_MORNINGS: 'early_mornings',
  CHAIN_RESTAURANTS: 'chain_restaurants',
  SHARED_TRANSFERS: 'shared_transfers',
  NIGHTLIFE: 'nightlife',
} as const);

export type WhatShouldAvoidWhenPlanning =
  (typeof WhatShouldAvoidWhenPlanning)[keyof typeof WhatShouldAvoidWhenPlanning];

export const allWhatShouldAvoidWhenPlanning: [
  WhatShouldAvoidWhenPlanning,
  ...WhatShouldAvoidWhenPlanning[],
] = Object.values(WhatShouldAvoidWhenPlanning) as [
  WhatShouldAvoidWhenPlanning,
  ...WhatShouldAvoidWhenPlanning[],
];

export default WhatShouldAvoidWhenPlanning;
